import { Uploadable } from '@app/classes/uploadable';
import { Chippable } from '@app/interfaces';
import { DocumentTag } from '@app/models/documents/document-tag.model';
import { DocumentAllowedFileTypes } from '@app/modules/documents-v2/enums/document-allowed-file-types.enum';

export class CompanyDocumentUploadable extends Uploadable {
    /**
     * Is the company document public
     */
    isPublic = false;

    /**
     * Tags to be attached to the company document
     */
    tags: DocumentTag[] = [];

    /**
     * Is there already a company document with this name?
     * Humi does not allow duplicate company document names in a company
     */
    duplicatesPersistedDocumentName = false;

    /**
     * Is there another uploadable with the same name.
     * Humi does not allow duplicate company document names in a company
     */
    duplicatesLocalDocumentName = false;

    /*
     * We added support for images in SQA-3650 for "View Only" Documents
     */
    protected readonly allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'];
    protected readonly allowedExtensions = DocumentAllowedFileTypes.acknowledgement.split(',');

    constructor(file: File) {
        super(file);
        this.afterConstruct();
    }

    /**
     * The autocomplete emits Chippables which are either new Chippables or Document Tags we've already passed in
     * Before we add this items to our tags, we make sure they are all proper Document Tags
     */
    addTagsFromChips(chippables: (Chippable | DocumentTag)[]): void {
        this.tags = chippables.map((c) => {
            if (c instanceof DocumentTag) {
                return c;
            }

            return new DocumentTag({ name: c.chipLabel });
        });
    }

    protected checkIsReadyToUpload(): boolean {
        return !this.duplicatesPersistedDocumentName && !this.duplicatesLocalDocumentName;
    }

    protected setErrors(): void {
        const { duplicatesPersistedDocumentName, duplicatesLocalDocumentName } = this;

        this.nameFormControl.setErrors({
            duplicatesPersistedDocumentName,
            duplicatesLocalDocumentName,
        });
    }
}
